import React, { useState } from "react";
import ReactPlayer from "react-player";
import "./projectBox.scss";

const ProjectBox = (props) => {
  const [isHovering, setIsHovering] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const handleMouseEnter = () => {
    setIsHovering(true);
    // Start loading video but don't show it yet
    if (props.link) {
      setShowVideo(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    setVideoReady(false);
    setShowVideo(false);
  };

  const handleReady = () => {
    setVideoReady(true);
  };

  return (
    <>
      <div 
        className="portfolio__box"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="portfolio__image-container">
          <img src={props.preview} alt="project" className={`portfolio__preview-image ${videoReady ? 'fade-out' : ''}`} />
          {showVideo && props.link && (
            <div className={`portfolio__video-preview ${videoReady ? 'fade-in' : ''}`}>
              <ReactPlayer
                url={props.link}
                playing={isHovering && videoReady}
                muted
                loop
                width="100%"
                height="100%"
                style={{ position: 'absolute', top: 0, left: 0 }}
                onReady={handleReady}
              />
            </div>
          )}
        </div>
        <div className="portfolio__hover-info">
          <div className="text-center">
            <p className="weight300">{props.title}</p>
          </div>
        </div>
      </div>
    </>
  )
};

export default ProjectBox;
